import { render, staticRenderFns } from "./VirtualVisit.vue?vue&type=template&id=c2b973ee&scoped=true&"
import script from "./VirtualVisit.vue?vue&type=script&lang=js&"
export * from "./VirtualVisit.vue?vue&type=script&lang=js&"
import style0 from "./VirtualVisit.vue?vue&type=style&index=0&id=c2b973ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b973ee",
  null
  
)

export default component.exports